import { render } from "./quiz-student.vue?vue&type=template&id=69497242&ts=true"
import script from "./quiz-student.vue?vue&type=script&lang=ts"
export * from "./quiz-student.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__